import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { ConfirmationDialog, makeStyles } from '@ellucian/react-design-system/core';
import {
    spacing40,
    widthFluid,
} from '@ellucian/react-design-system/core/styles/tokens';

const useStyles = makeStyles(theme => ({
    actionButton: {
        marginRight: spacing40,
    },

    [theme.breakpoints.down('sm')]: {
        actionButton: {
            margin: 'inherit',
            width: widthFluid,
        },
    },
}));

const DeleteConfirmationDialog = ({ isOpen, onPrimaryClick, onSecondaryClick, title, content, contentText, primaryActionText, secondaryActionText }) => {
    const { formatMessage } = useIntl();
    const classes = useStyles();
    const customId = 'DeleteConfirmationDialog';

    const DialogProps = {
        id: `${customId}_Dialog`,
    };
    const DialogActionsProps = {
        id: `${customId}_DialogActions`
    };
    const DialogContentProps = {
        id: `${customId}_DialogContent`,
    };
    const DialogContentTextProps = {
        id: `${customId}_DialogContentText`,
    };
    const DialogTitleProps = {
        id: `${customId}_DialogTitle`,
    };
    const primaryActionProps = {
        id: `${customId}_primaryAction`,
        className: classes.actionButton,
    };
    const secondaryActionProps = {
        id: `${customId}_secondaryAction`,
        className: classes.actionButton,
    };

    return (
        <ConfirmationDialog
            content={content}
            contentText={contentText}
            DialogProps={DialogProps}
            DialogActionsProps={DialogActionsProps}
            DialogContentProps={DialogContentProps}
            DialogContentTextProps={DialogContentTextProps}
            DialogTitleProps={DialogTitleProps}
            open={isOpen}
            primaryActionOnClick={onPrimaryClick}
            primaryActionProps={primaryActionProps}
            primaryActionText={primaryActionText || formatMessage({ id: 'actionDelete' })}
            secondaryActionOnClick={onSecondaryClick}
            secondaryActionProps={secondaryActionProps}
            secondaryActionText={secondaryActionText || formatMessage({ id: 'actionCancel' })}
            title={title}
        />
    );
};

DeleteConfirmationDialog.propTypes = {
    content: PropTypes.node,
    contentText: PropTypes.string,
    isOpen: PropTypes.bool.isRequired,
    onPrimaryClick: PropTypes.func.isRequired,
    onSecondaryClick: PropTypes.func.isRequired,
    primaryActionText: PropTypes.string,
    secondaryActionText: PropTypes.string,
    title: PropTypes.string,
};

export default DeleteConfirmationDialog;
